class AdditionalInformationStageController {}

export default AdditionalInformationStageController;
